module.exports = __webpack_public_path__ + "static/media/faq2.5b606f1a.png";